import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sc-not-banner rounded-lg pa-2"},[_c('div',{class:[`type-${_vm.srcImg}`,'img-container rounded']},[_c('img',{attrs:{"src":`/img/icons/${_vm.srcImg}.png`}})]),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]),_c(VBtn,{attrs:{"icon":""},on:{"click":function($event){return _vm.$store.dispatch('close_notif')}}},[_c(VIcon,[_vm._v("mdi-close")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }